import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import { useIndexedDB } from 'react-indexed-db'
import pause from '../../Assets/Bisoft_UI/Buttons/Active with shadow/pause_btn@3x.png'
import backY from '../../Assets/Bisoft_UI/Buttons/Active without shadow/back.png'
import play from '../../Assets/Bisoft_UI/Buttons/Active with shadow/play-run.png'
import close from '../../Assets/Bisoft_UI/Buttons/Active without shadow/close.png'
import cameraP5 from '../../Assets/Bisoft_UI/AppMode/camera(speech).png'
import selectBarfive from '../../Assets/Bisoft_UI/AppMode/selectBarfive.png'
import popupCardfive from '../../Assets/Bisoft_UI/AppMode/popupCardfive.png'
import popupCardone from '../../Assets/Bisoft_UI/AppMode/popupCardone.png'
import projectbig from '../../Assets/Bisoft_UI/AppMode/projectBig.png'
import musicIcon from '../../Assets/Bisoft_UI/AppMode/musicIcon.png'
import NavBar from './NavBar'
import styles from './Appmode.module.css'
import { connect } from 'react-redux'
import * as tf from '@tensorflow/tfjs'
import * as speechCommands from '@tensorflow-models/speech-commands'

import { vadDetector } from './teachableMachine/audio/vadDetector'
import SpeechHelpOverlay from './SpeechHelpOverlay'
import ClassPredictionsPanel from './ClassPredictionsPanel'

export const textFontSize = {
    1: '17px',
    2: '25px',
    3: '35px',
}
let send = false

// background → silence / fan / noise
// human → any voice sound (talking, shouting, laughing, whispering)
// non_human → clap, whistle, siren, alarm, knock, etc.

const SpeechRecognitionPage = (props) => {
    const [allDetails, setAllDetails] = useState(() => JSON.parse(sessionStorage.getItem('allDetails')) || {})

    useEffect(() => {
        // Refresh allDetails from session storage on mount and periodically or on focus
        const refreshDetails = () => {
            const freshDetails = JSON.parse(sessionStorage.getItem('allDetails')) || {}
            setAllDetails(freshDetails)
        }
        
        window.addEventListener('focus', refreshDetails)
        return () => window.removeEventListener('focus', refreshDetails)
    }, [])

    const enable = JSON.parse(sessionStorage.getItem('enable'))
    const connectedDevice = sessionStorage.getItem('connectedDevice') || ''
    // const zingVersion = sessionStorage.getItem('zingVersion') || '0.0.0'
    // const deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'
    const history = useHistory()
    const readBytesInterval = useRef()
    const { getByID } = useIndexedDB('ProgramData')
    const [isPlay, setPlay] = useState(false)
    const [text, setText] = useState({ text: 'value', size: '17px' })
    const [image, setImage] = useState()
    const [popup, setPopup] = useState(false)
    const [display, setDisplay] = useState(true)
    const [results, setResults] = useState()
    const [size, setSize] = useState(0)
    const [select, setSelect] = useState('None')
    const [usbTxValue, setUsbTxValue] = useState(0)
    const [usbTxText, setUsbTxText] = useState('Value')
    const [customModel, setCustomModel] = useState(null)
    const [recognizer, setRecognizer] = useState(null)
    const [labels, setLabels] = useState([])
    const [audioClasses, setAudioClasses] = useState({})
    const [classPredictions, setClassPredictions] = useState({})
    const [speechText, setSpeechText] = useState('');
    const [speakerName,setSpeakerName] = useState('');
    const [validationMessage, setValidationMessage] = useState('')
    const SpeechRecognitionRef = useRef(null)

    // Speech Commands transfer learning model flag
    const [isSpeechCommandsModel, setIsSpeechCommandsModel] = useState(false)
    const isSpeechCommandsModelRef = useRef(false)
    useEffect(() => { isSpeechCommandsModelRef.current = isSpeechCommandsModel }, [isSpeechCommandsModel])

    // Multi-model state (Phase 2 — human vs env sub-models)
    const [isMultiModel, setIsMultiModel] = useState(false)
    const [humanModel, setHumanModel] = useState(null)
    const [envModel, setEnvModel] = useState(null)
    const [humanLabels, setHumanLabels] = useState([])
    const [envLabels, setEnvLabels] = useState([])
    // Stable refs so the recognizer callback always reads the latest values
    // without being re-registered every render.
    const humanModelRef = useRef(null)
    const envModelRef   = useRef(null)
    const humanLabelsRef = useRef([])
    const envLabelsRef   = useRef([])
    const isMultiModelRef = useRef(false)
    const audioClassesRef = useRef({})
    // Keep refs in sync with state
    useEffect(() => { humanModelRef.current   = humanModel   }, [humanModel])
    useEffect(() => { envModelRef.current     = envModel     }, [envModel])
    useEffect(() => { humanLabelsRef.current  = humanLabels  }, [humanLabels])
    useEffect(() => { envLabelsRef.current    = envLabels    }, [envLabels])
    useEffect(() => { isMultiModelRef.current = isMultiModel }, [isMultiModel])
    useEffect(() => { audioClassesRef.current = audioClasses }, [audioClasses])

    const [ishelpButton, sethelpButton] = useState(false)
    const handleClickhelpbtn = () => {
        sethelpButton(true)
    }
    const [slideDirection, setSlideDirection] = useState(
        sessionStorage.getItem('slideDirection')
    )
    const predictingRef = useRef(false)
    const audioBufferRef = useRef([])
    // Queue of {val, triggerWord} entries waiting for speaker to say a word
    const pendingActionsRef = useRef([])
    // Stable ref so STT onresult callback always sees the latest allDetails
    const allDetailsRef = useRef(allDetails)
    useEffect(() => { allDetailsRef.current = allDetails }, [allDetails])
    

    const startSpeechToText = () => {
        if (SpeechRecognitionRef.current) return;

        const SpeechRecognition =
            window.SpeechRecognition || window.webkitSpeechRecognition

        if (!SpeechRecognition) {
            console.error('Speech recognition not supported in this browser.')
            return
        }

        const recognition = new SpeechRecognition()
        
        recognition.continuous = true
        recognition.interimResults = true
        recognition.lang = 'en-US'

        recognition.onresult = (event) => {
            let transcript = ''
            for (let i = 0; i < event.results.length; i++) {
                transcript += event.results[i][0].transcript
            }
            setSpeechText(transcript)

            // Check if any pending speakerSayThis action is triggered
            if (pendingActionsRef.current.length > 0) {
                const lower = transcript.toLowerCase()
                const remaining = []
                for (const pending of pendingActionsRef.current) {
                    if (lower.includes(pending.triggerWord)) {
                        fireAction(pending.val)
                    } else {
                        remaining.push(pending)
                    }
                }
                pendingActionsRef.current = remaining
            }
        }

        recognition.onend = () => {
            SpeechRecognitionRef.current = null
        }

        recognition.start()
        SpeechRecognitionRef.current = recognition
    }

    const stopSpeechToText = () => {
        if (SpeechRecognitionRef.current) {
            SpeechRecognitionRef.current.stop()
            SpeechRecognitionRef.current = null
        }
    }

    const getDeviceName = () => {
        let deviceName = 'PC'
        switch (connectedDevice) {
            case 'Ace':
                deviceName = 'PC'
                break
            case 'Humanoid':
                deviceName = 'Zing'
                break
            case 'Hexapod':
                deviceName = 'Crawl-e'
                break
            case 'Klaw':
                deviceName = 'Klaw-b'
                break
            case 'Autoki':
                deviceName = 'Autoki'
                break
            default:
                deviceName = connectedDevice
        }
        return deviceName
    }
    const closeModal = () => {
        sethelpButton(false)
    }
    const handleDialogModalClose = () => {
        setSelect('None')
    }
    const isLoadingModelRef = useRef(false)
    const loadModel = async () => {
        if (isLoadingModelRef.current) return
        try {
            isLoadingModelRef.current = true
            setResults('Loading Custom Model...')

            const currentModelId =
                props.appModeStorage.trainMachine.currentModelId
            const modelMeta = props.appModeStorage.trainMachine.camModels.find(
                (m) => m.modelId === currentModelId
            )

            if (!modelMeta || !modelMeta.isGenerateTensor) {
                alert('Please train the model first!')
                return
            }

            const classesObj = modelMeta.AudioClasses || {}
            setAudioClasses(classesObj)

            // Initialize classPredictions keyed by classKey (the AudioClasses dict key).
            // Training now labels examples as String(classKey), so the inference callback
            // updates entries with the same key — using c.id would create a mismatch.
            const initialPreds = {}
            Object.entries(classesObj).forEach(([classKey, c]) => {
                if (c) {
                    initialPreds[classKey] = {
                        className: c.className,
                        confidence: 0,
                    }
                }
            })
            setClassPredictions(initialPreds)

            if (modelMeta.isSpeechCommandsModel) {
                // ── TF Speech Commands transfer learning path ─────────────
                const scLabels = modelMeta.speechCommandsLabels || []
                const baseRec = speechCommands.create('BROWSER_FFT')
                await baseRec.ensureModelLoaded()
                const transferRec = baseRec.createTransfer(`transfer-${currentModelId}`)
                // Try new _audio path first; fall back to legacy path for older trained models
                try {
                    await transferRec.load(`indexeddb://${currentModelId}_audio`)
                } catch (_) {
                    await transferRec.load(`indexeddb://${currentModelId}`)
                }
                // Restore word labels (not in localStorage since we saved with a custom path)
                transferRec.words = scLabels
                setRecognizer(transferRec)
                setLabels(scLabels)
                setCustomModel(transferRec)   // non-null so startPlay guard passes
                setIsSpeechCommandsModel(true)
                setIsMultiModel(false)
            } else if (modelMeta.isMultiModel) {
                const rec = speechCommands.create('BROWSER_FFT')
                await rec.ensureModelLoaded()
                setRecognizer(rec)
                // ── Phase-2 multi-model path ──────────────────────────────
                const hLabels = modelMeta.humanAudioLabels || []
                const eLabels = modelMeta.envAudioLabels   || []

                let hModel = null, eModel = null
                if (hLabels.length >= 1) {
                    try {
                        hModel = await tf.loadLayersModel(
                            `indexeddb://${currentModelId}_human`
                        )
                    } catch (e) {
                        console.warn('Human sub-model not found:', e.message)
                    }
                }
                if (eLabels.length >= 2) {
                    try {
                        eModel = await tf.loadLayersModel(
                            `indexeddb://${currentModelId}_env`
                        )
                    } catch (e) {
                        console.warn('Env sub-model not found:', e.message)
                    }
                }

                setHumanModel(hModel)
                setEnvModel(eModel)
                setHumanLabels(hLabels)
                setEnvLabels(eLabels)
                setIsMultiModel(true)
                await vadDetector.initializeVAD()
                const combinedLabels = [...hLabels, ...eLabels]
                setLabels(combinedLabels)
                setCustomModel(hModel || eModel)
            } else {
                // ── Single-model (dense fallback) path ────────────────────
                const rec = speechCommands.create('BROWSER_FFT')
                await rec.ensureModelLoaded()
                setRecognizer(rec)
                const loadedModel = await tf.loadLayersModel(
                    `indexeddb://${currentModelId}`
                )
                const audioLabels = modelMeta.audioLabels || []
                if (audioLabels.length === 0) {
                    console.warn('Model metadata contains no audioLabels')
                }
                setCustomModel(loadedModel)
                setLabels(audioLabels)
                setIsMultiModel(false)
            }
            setResults('Model Ready')
        } catch (err) {
            console.error('Failed to load model', err)
            setResults('Error loading model')
        }
    }
    useEffect(() => {
        if (isPlay) {
            setTimeout(() => {
                if (enable.s1.pc === true) {
                    props.worker.postMessage({
                        type: 'writeArray',
                        value: [85, 83, 0],
                    })
                }
                // Only reset if no prediction has come in
                setResults((prev) =>
                    prev === undefined ? 'listening...' : prev
                )
            }, 150)
        }
    }, [isPlay])

    useEffect(() => {
        if (isPlay === true && enable.s1.pc === true) {
            // if (
            //     deviceVersion?.startsWith('2') ||
            //     (deviceVersion?.startsWith('1') &&
            //         ['Ace'].includes(connectedDevice)) ||
            //     connectedDevice == 'Roboki'
            // ) {
            props.worker.postMessage({
                type: 'writeArray',
                value: [85, 83, 0],
            })
            // } else {
            //     if (props.webSerial.port !== undefined) {
            //         sendBytes([85, 83, 0], props.webSerial.port)
            //         send = true
            //     }
            // }
        }
    }, [isPlay])

    useEffect(() => {
        // if (
        //     enable.s1.pc === true &&
        //     isPlay === true &&
        //     !deviceVersion?.startsWith('1') &&
        //     !(
        //         ['Humanoid', 'Hexapod'].includes(connectedDevice) &&
        //         deviceVersion?.startsWith('2')
        //     ) &&
        //     connectedDevice !== 'Roboki'
        // ) {
        //     readBytesInterval.current = setInterval(async () => {
        //         let bytes
        //         if (send === true) {
        //             bytes = await readBytesAppMode(props.webSerial.port, '')
        //             send = false
        //             if (bytes !== undefined && bytes.split('\n').length >= 2) {
        //                 let length = bytes.split('\n').length
        //                 bytes = bytes.split('\n')[length - 1]
        //             }
        //             if (
        //                 bytes !== undefined &&
        //                 2 < bytes.length <= 5 &&
        //                 bytes.slice(0, 2) === 'US'
        //             ) {
        //                 Object.keys(allDetails).map((value) => {
        //                     if (allDetails[value].usbValue === bytes.slice(2)) {
        //                         if (allDetails[value].displayText !== null) {
        //                             setText(allDetails[value].displayText)
        //                         }
        //                         if (allDetails[value].image !== null) {
        //                             getByID(allDetails[value].id).then(
        //                                 (event) => {
        //                                     setImage(event.imageURL)
        //                                 }
        //                             )
        //                         }
        //                         if (allDetails[value].sliderOption === 'TX1') {
        //                             sendBytes(
        //                                 [
        //                                     85,
        //                                     83,
        //                                     Number(
        //                                         allDetails[value].sliderValue
        //                                     ),
        //                                 ],
        //                                 props.webSerial.port
        //                             )
        //                             send = true
        //                         }
        //                         setSize(allDetails[value].selectedSize)
        //                     }
        //                 })
        //             }
        //         }
        //     }, 10000)
        // }

        const handleWorkerMessage = (e) => {
            if (e.data.type === 'Appread') {
                console.log('USB RX Data Received:', e.data.value)
                let bytes = e.data.value

                // Standardized Protocol Check: [85, 83, value] ('U', 'S', value)
                let uIndex = bytes.indexOf(85)
                if (uIndex !== -1 && bytes[uIndex + 1] === 83) {
                    const receivedValue = bytes[uIndex + 2]
                    setUsbTxValue(receivedValue)

                    Object.keys(allDetails).forEach((key) => {
                        const val = allDetails[key]
                        if (val.usbValue == receivedValue) {
                            if (val.displayText !== null) {
                                setText({
                                    text: val.displayText,
                                    size: `${textFontSize[val?.selectedSize] ?? '17px'}`,
                                })
                            }
                            if (val.image !== null) {
                                getByID(val.id).then((event) => {
                                    setImage(event.imageURL)
                                })
                            }
                            // Reciprocal TX Logic if configured
                            if (val.sliderOption === 'TX1') {
                                props.worker.postMessage({
                                    type: 'writeArray',
                                    value: [
                                        85,
                                        83,
                                        Number(val.sliderValue),
                                    ],
                                })
                                send = true
                            }
                            setSize(val.selectedSize)
                        }
                    })
                }
            }
        }

        props.worker.addEventListener('message', handleWorkerMessage)
        return () => {
            props.worker.removeEventListener('message', handleWorkerMessage)
        }
    }, [allDetails])

    const Popup = (props) => {
        useEffect(() => {
            if (props.trigger) {
                props.set(false)
            }
        }, [])

        return props.trigger ? (
            <div className={styles.popup}>
                <div className={styles.popupInner}>
                    <img
                        src={close}
                        draggable="false"
                        alt="close"
                        style={{
                            position: 'absolute',
                            width: '3vw',
                            bottom: '70vh',
                            right: '-1.2vw',
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            setPopup(false)
                            props.set(true)
                        }}
                    />
                </div>
                {props.displayImage !== popupCardfive ? (
                    <div style={{ zIndex: '3' }}>
                        <img
                            style={{ width: '100%', maxWidth: '60vw' }}
                            src={props.displayImage}
                            height="350vh"
                            width="350vw"
                            alt="displayImage"
                            draggable="false"
                        />
                        <p
                            style={{
                                fontSize: `${2 * Number(props.font)}vh`,
                                zIndex: '4',
                                textAlign: 'center',
                            }}
                        >
                            {props.displayText}
                        </p>
                    </div>
                ) : (
                    ''
                )}
            </div>
        ) : (
            ''
        )
    }

    useEffect(()=>{
        loadModel()
    },[])

    const predictionHistoryRef = useRef([])

    const startPrediction = async (labelsToUse) => {
        if (!recognizer || !customModel) return
        if (predictingRef.current) return // prevent multiple concurrent listeners
        if (!Array.isArray(labelsToUse) || labelsToUse.length === 0) {
            console.warn(
                'startPrediction called with invalid labels',
                labelsToUse
            )
            return
        }

        predictingRef.current = true
        predictionHistoryRef.current = [] // Reset history

        if (isSpeechCommandsModelRef.current) {
            // ── Speech Commands transfer path ─────────────────────────────
            // The transfer recognizer handles z-normalisation, feature
            // extraction, and classification internally. result.scores is
            // already a softmax array indexed by recognizer.wordLabels().
            recognizer.listen(
                async (result) => {
                    const scores = Array.from(result.scores)
                    const wordLabels = recognizer.wordLabels()
                    const audioClassesToUse = audioClassesRef.current || {}

                 
                    predictionHistoryRef.current.push(scores)
                    if (predictionHistoryRef.current.length > 5) {
                        predictionHistoryRef.current.shift()
                    }
                    const averaged = scores.map((_, i) => {
                        const sum = predictionHistoryRef.current.reduce((s, h) => s + h[i], 0)
                        return sum / predictionHistoryRef.current.length
                    })

                    let maxIndex = 0, maxProb = -1
                    averaged.forEach((p, i) => { if (p > maxProb) { maxProb = p; maxIndex = i } })

                    // wordLabels are String(classKey) from training — direct O(1) lookup
                    const detectedClassId = wordLabels[maxIndex]

                    setClassPredictions((prev) => {
                        const next = { ...prev }
                        wordLabels.forEach((classId, idx) => {
                            // classId = String(classKey), audioClassesToUse keyed by classKey
                            const classData = audioClassesToUse[classId]
                            if (classData) {
                                next[classId] = {
                                    className: classData.className,
                                    confidence: averaged[idx] || 0,
                                }
                            }
                        })
                        return next
                    })

                    if (maxProb > 0.85) {
                        const classInfo = audioClassesToUse[detectedClassId]
                        if (classInfo && classInfo.className !== 'Background_Noise') {
                            setResults(classInfo.className)
                            handleDetectedAction(detectedClassId)
                            setSpeakerName(classInfo.className)
                            startSpeechToText()
                        }
                    }
                },
                {
                    probabilityThreshold: 0,
                    invokeCallbackOnNoiseAndUnknown: true,
                    overlapFactor: 0.75,
                }
            )
        } else {
            // ── Legacy manual spectrogram path (dense / multi-model) ──────
            recognizer.listen(
                async (result) => {
                    audioBufferRef.current.push(result.spectrogram.data)
                    if (audioBufferRef.current.length < 4) return

                    const combinedData = []
                    for (const chunk of audioBufferRef.current) {
                        for (let i = 0; i < chunk.length; i++) combinedData.push(chunk[i])
                    }
                    audioBufferRef.current = []

                    const normalizedData = combinedData.map((v) => (v + 100) / 100)

                    let tensor, labelsForPrediction, modelForPrediction, isVoice

                    if (isMultiModelRef.current) {
                        isVoice = vadDetector.isSpeechDetected()
                        modelForPrediction = isVoice ? humanModelRef.current : envModelRef.current
                        labelsForPrediction = isVoice ? humanLabelsRef.current : envLabelsRef.current
                        if (!modelForPrediction || !labelsForPrediction?.length) return
                        tensor = tf.tidy(() => {
                            const t = tf.tensor(normalizedData, [1, 172, 232, 1])
                            const s = modelForPrediction.layers[0].batchInputShape
                            return s.length === 2 ? t.reshape([1, -1])
                                : s.length === 4 ? tf.image.resizeBilinear(t, [s[1], s[2]])
                                : t
                        })
                    } else {
                        modelForPrediction = customModel
                        labelsForPrediction = labelsToUse
                        if (!modelForPrediction) return
                        tensor = tf.tidy(() => {
                            const t = tf.tensor(normalizedData, [1, 172, 232, 1])
                            const s = modelForPrediction.layers[0].batchInputShape
                            return s.length === 2 ? t.reshape([1, -1])
                                : s.length === 4 ? tf.image.resizeBilinear(t, [s[1], s[2]])
                                : t
                        })
                    }

                    try {
                        const prediction = modelForPrediction.predict(tensor)
                        const probabilities = prediction.dataSync()
                        prediction.dispose()

                        predictionHistoryRef.current.push(probabilities)
                        if (predictionHistoryRef.current.length > 5) predictionHistoryRef.current.shift()

                        const averagedProbabilities = new Float32Array(probabilities.length)
                        for (let i = 0; i < probabilities.length; i++) {
                            let sum = 0
                            for (const h of predictionHistoryRef.current) sum += h[i]
                            averagedProbabilities[i] = sum / predictionHistoryRef.current.length
                        }

                        let maxIndex = 0, maxProb = -1
                        for (let i = 0; i < averagedProbabilities.length; i++) {
                            if (averagedProbabilities[i] > maxProb) { maxProb = averagedProbabilities[i]; maxIndex = i }
                        }

                        if (maxIndex < 0 || maxIndex >= labelsForPrediction.length) return

                        const detectedClassId = labelsForPrediction[maxIndex]
                        if (typeof detectedClassId === 'undefined') return

                        const audioClassesToUse = audioClassesRef.current || {}
                        const classInfo = Object.values(audioClassesToUse).find(
                            (c) => c && Number(c.id) === Number(detectedClassId)
                        )

                        setClassPredictions((prev) => {
                            const next = { ...prev }
                            labelsForPrediction.forEach((classId, idx) => {
                                const classData = Object.values(audioClassesToUse).find(
                                    (c) => c && Number(c.id) === Number(classId)
                                )
                                if (classData) {
                                    next[classId] = {
                                        className: classData.className,
                                        confidence: averagedProbabilities[idx] || 0,
                                    }
                                }
                            })
                            const otherLabels = isVoice ? envLabelsRef.current : humanLabelsRef.current
                            otherLabels.forEach((id) => { if (next[id]) next[id].confidence = 0 })
                            return next
                        })

                        if (maxProb > 0.85 && classInfo) {
                            if (classInfo.className !== 'Background_Noise') {
                                setResults(classInfo.className)
                                handleDetectedAction(detectedClassId)
                                setSpeakerName(classInfo.className)
                                startSpeechToText()
                            }
                        }
                    } finally {
                        tensor.dispose()
                    }
                },
                {
                    includeSpectrogram: true,
                    probabilityThreshold: 0.5,
                    overlapFactor: 0.75,
                }
            )
        }
    }
    // Execute an action entry from allDetails immediately
    const fireAction = (val) => {
        if (val.displayText)
            setText({
                text: val.displayText,
                size: textFontSize[val.selectedSize] || '17px',
            })
        if (val.image) {
            getByID(val.id).then((event) => setImage(event.imageURL))
        }
        if (enable.s1.pc && val.sliderOption === 'TX1') {
            setUsbTxValue(Number(val.sliderValue))
            props.worker.postMessage({
                type: 'writeArray',
                value: [85, 83, Number(val.sliderValue)],
            })
        }
    }

    const handleDetectedAction = (classId) => {
        const classIdStr = String(classId)
        Object.entries(allDetailsRef.current).forEach(([key, val]) => {
            if (
                String(val.speechText) === classIdStr ||
                String(val.selectedObject) === classIdStr ||
                String(key) === classIdStr
            ) {
                const triggerWord = val.speakerSayThis?.trim()
                if (triggerWord) {
                    // Defer: only fire when speaker says this word
                    pendingActionsRef.current.push({
                        val,
                        triggerWord: triggerWord.toLowerCase(),
                    })
                    startSpeechToText() // ensure STT is running to catch the word
                } else {
                    fireAction(val)
                }
            }
        })
    }
    const startPlay = async () => {
        if (!customModel || !recognizer) {
            setValidationMessage('No trained model found. Please train a model on the Control page first.')
            return
        }
        const hasCondition = Object.keys(allDetails).length > 0 && select !== "None"
        if (!hasCondition) {
            setValidationMessage('No conditions configured. Please set up actions on the Control page before running.')
            return
        }
        setValidationMessage('')
        setPlay(true)
        setResults('')

        if (isMultiModel) {
            vadDetector.startVAD()
        }

        startPrediction(labels)
    }


    const stopPlay = () => {
        if (recognizer) {
            recognizer.stopListening()
            predictingRef.current = false
            audioBufferRef.current = []
        }
        pendingActionsRef.current = []

        if (isMultiModel) {
            vadDetector.stopVAD()
        }

        stopSpeechToText()
        setPlay(false)
        setResults('Stopped')
    }

    const optionSelected = (event) => {
        setSelect(event.target.value)
    }

    return (
        <div className='relative'> 
            {/* NavBar */}
            
            <div> 
                <NavBar
                    selectbar={selectBarfive}
                    selectbarwidth="90%"
                    headers={[
                        { name: 'Enable', color: 'white' },
                        { name: 'Control', color: 'white' },
                        { name: 'Run', color: 'white' },
                    ]}
                    showHelp={true}
                    handleHelp={handleClickhelpbtn}
                />
            </div>
            {/* Main */}
            <div
                className={`${
                    slideDirection === 'true' ? 'slide-right' : 'slide-left'
                }`}
                style={{ position: 'relative' }}
            >
                <div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '22vh',
                            right: '25vw',
                            zIndex: '1',
                        }}
                    >
                        <label>
                            <select
                                className={styles.selectBox}
                                style={{
                                    position: 'absolute',
                                    right: '14vw',
                                    top: '16vh',
                                    width: '19.4vw',
                                    height: '6.2vh',
                                    font: 'Halcyon Regular',
                                    fontFamily: 'Halcyon Regular',
                                    fontSize: '15px',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                }}
                                onChange={optionSelected}
                                value={select}
                            >
                                <option defaultValue={'None'}>
                                    Select option
                                </option>
                                <option value="text">Text </option>
                                <option value="usbTx">
                                    {getDeviceName()} received data [USB
                                    TX]{' '}
                                </option>

                                <option value="classPrediction">
                                    Class Prediction
                                </option>
                            </select>
                        </label>
                    </div>
                    {/* Element to Move Dynamically */}
                    <div
                        style={{
                            position: 'relative',
                            top: '53vh',
                            left: '2vh',
                            font: 'Halcyon Regular',
                            fontFamily: 'Halcyon Regular',
                            fontSize: '22px',
                            zIndex: '1',
                            textAlign: 'center',
                            // fontWeight:
                        }}
                    >
                        {select === 'text' && (
                            <strong style={{ fontSize: text.size }}>
                                {text.text}
                            </strong>
                        )}

                        {select === 'startListing' && (
                            <div style={{ textAlign: 'center'  }}>
                                <div ><strong>{speakerName}:</strong> <p style={{ maxWidth:'400px' }}>{speechText} </p></div>
                            </div>
                        )}

                        {select === 'usbTx' && (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <input
                                    style={{
                                        border: 'none',
                                        outline: 'none',
                                        width: '150px',
                                        textAlign: 'center',
                                    }}
                                    onChange={(e) =>
                                        setUsbTxText(e.target.value)
                                    }
                                    value={usbTxText}
                                />
                                <p
                                    style={{
                                        marginBottom: '0',
                                        marginLeft: '15px',
                                    }}
                                >
                                    {usbTxValue}
                                </p>
                            </div>
                        )}

                        
                    </div>
                    <img
                        src={popupCardfive}
                        draggable="false"
                        alt="popupCardfive"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '39vh',
                            left: '18vw',
                            width: '23.5vw',
                            height: '62vh',
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                    <img
                        src={cameraP5}
                        draggable="false"
                        alt="popupCardfive"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '35vh',
                            left: '18vw',
                            width: '6vw',
                            // height: "12vh",
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                    <p
                        style={{
                            position: 'absolute',
                            left: '18%',
                            top: '63%',
                            transform: 'translate(-50%,0%)',
                            fontFamily: 'Halcyon Regular',
                            fontSize: '15px',
                            textAlign: 'center',
                        }}
                    >
                        Camera Inactive
                    </p>
                    {display === true && image !== null ? (
                        <div
                            style={{
                                margin: 0,
                                position: 'relative',
                                top: '36vh',
                                left: '83vw',
                                width: '19vw',
                                height: '62vh',
                                cursor: 'pointer',
                                transform: 'translate(-50%, -50%)',
                                backgroundImage: `url(${popupCardfive})`,
                                backgroundSize: '100% 100%',
                                backgroundRepeat: 'no-repeat',
                            }}
                        >
                            <img
                                src={image}
                                draggable="false"
                                // alt="displayimage"
                                style={{
                                    margin: 0,
                                    position: 'absolute',
                                    width: '85%',
                                    top: '50%',
                                    left: '51%',
                                    transform: 'translate(-50%,-50%)',
                                }}
                                onClick={() => {
                                    setPopup(true)
                                }}
                            />
                        </div>
                    ) : (
                        <>
                            <img
                                src={popupCardfive}
                                draggable="false"
                                alt="displayimage"
                                style={{
                                    margin: 0,
                                    position: 'absolute',
                                    top: '39vh',
                                    left: '83vw',
                                    width: '19vw',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            />
                        </>
                    )}
                    <Popup
                        trigger={popup}
                        displayImage={image}
                        displayText={text.text}
                        font={size}
                        set={setDisplay}
                    />
                    <img
                        src={popupCardfive}
                        draggable="false"
                        alt="popupCardfive"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '50.5vh',
                            left: '51.2vw',
                            width: '26.8vw',
                            height: '39vh',
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                    <img
                        src={popupCardone}
                        draggable="false"
                        alt="popupCardone"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '23vh',
                            left: '50.3vw',
                            width: '34vw',
                            height: '33vh',
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                    <img
                        src={musicIcon}
                        draggable="false"
                        alt="popupCardone"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '23vh',
                            left: '45.3vw',
                            width: '7vw',
                            // height: "10vh",
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                    <img
                        src={projectbig}
                        draggable="false"
                        alt="projectbig"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '55.8vh',
                            left: '51.4vw',
                            width: '24vw',
                            height: '23vh',
                            borderWidth: 2,
                            borderColor: 'black',
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                </div>
            </div>

            {/* Footer */}
            <div>
                {validationMessage && (
                    <p
                        style={{
                            position: 'absolute',
                            bottom: '13%',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            fontFamily: 'Halcyon Regular',
                            fontSize: '15px',
                            color: '#d9534f',
                            textAlign: 'center',
                            zIndex: 20,
                            background: 'rgba(255,255,255,0.9)',
                            padding: '6px 12px',
                            borderRadius: '6px',
                            maxWidth: '60vw',
                        }}
                    >
                        {validationMessage}
                    </p>
                )}
                <img
                    src={backY}
                    draggable="false"
                    alt="back"
                    style={{
                        margin: 0,
                        position: 'absolute',
                        top: '92vh',
                        right: '92.7vw',
                        width: '3vw',
                        cursor: 'pointer',
                        transform: 'translate(-50%, -50%)',
                        
                    }}
                    onClick={() => {
                        setSlideDirection(true)
                        sessionStorage.setItem('slideDirection', true)
                        if (isPlay) {
                            stopPlay()
                            setTimeout(history.push('/programmingPage'), 5000)
                            if (enable.s1.pc === true) {
                                clearInterval(readBytesInterval.current)
                            }
                        } else {
                            history.push('/programmingPage')
                        }
                    }}
                />
                {isPlay === false ? (
                    <img
                        src={play}
                        draggable="false"
                        alt="play"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '92vh',
                            left: '91.5vw',
                            width: '4vw',
                            cursor: 'pointer',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 20,
                        }}
                        onClick={startPlay}
                    />
                ) : (
                    <>
                        { results && select !== 'classPrediction' && (
                        <p
                            style={{
                                position: 'absolute',
                                bottom: '10%',
                                font: 'Halcyon Regular',
                                fontFamily: 'Halcyon Regular',
                                fontSize: '18px',
                                left: '52%',
                                transform: 'translateX(-50%)',
                                zIndex: 20,
                            }}
                        >
                            {results}
                        </p>)
                        }
                        <img
                            src={pause}
                            draggable="false"
                            alt="pause"
                            style={{
                                margin: 0,
                                position: 'absolute',
                                top: '92vh',
                                left: '91.5vw',
                                width: '4vw',
                                cursor: 'pointer',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 20,
                            }}
                            onClick={() => {
                                setPlay(false)
                                setUsbTxValue(0)
                                stopPlay()
                                if (enable.s1.pc === true) {
                                    props.worker.postMessage({
                                        type: 'writeArray',
                                        value: [85, 83, 0],
                                    })
                                    clearInterval(readBytesInterval.current)
                                }
                            }}
                        />
                    </>
                )}
            </div>
            {select === 'classPrediction' && (
                            <ClassPredictionsPanel
                                classPredictions={classPredictions}
                                onClose={handleDialogModalClose}
                            />
            )}

            {ishelpButton == true ? (
                <SpeechHelpOverlay onClose={closeModal} />
            ) : null}
        </div>
    )
}
const mapStateToProps = (state) => {
    console.log("mapStateToProps", state);

    return state
}

export default connect(mapStateToProps)(SpeechRecognitionPage)
